import ApiService from './api.service'

const MeterService = {    
    get(idCompany, companyName, addressSearchString, idType, typePublicCodes, personalAccount, nodeTypePublicCode, idNode, serialNumber, transportId, transportMeterId, transportSerialNumber, energyMeterTypeCode, isNodeLink, isDeleted, isObjectFree, withStatements, idProjectByObjects, idProjectByMeters, notInProjectIdByMeters, role, idTask, sortColumns, page, count) {
        return ApiService.get('api/meters', {
            params: {
                CompanyId: idCompany,
                CompanyName: companyName,
                AddressSearchString: addressSearchString,
                TypeId: idType,
                TypePublicCodes: typePublicCodes,
                PersonalAccount: personalAccount,
                NodeTypePublicCode: nodeTypePublicCode,
                NodeId: idNode,
                SerialNumber: serialNumber,
                TransportId: transportId,
                TransportMeterId: transportMeterId,
                TransportSerialNumber: transportSerialNumber,
                EnergyMeterTypeCode: energyMeterTypeCode,
                IsNodeLink:isNodeLink,
                IsDeleted: isDeleted,
                IsObjectFree: isObjectFree,
                WithStatements: withStatements,
                IdProjectByObjects: idProjectByObjects,
                IdProjectByMeters: idProjectByMeters,
                NotInProjectIdByMeters: notInProjectIdByMeters,
                Role: role,
                IdTask: idTask,
                SortColumns: sortColumns,
                Page: page,
                Count: count
            }
        })
    },

    getById(id) {
        return ApiService.get('api/meters/'+id)
    },

    create(serialNumber, idMeterType, idNode, transportSerial, idTransport, idTransportChannelType, transportChanelNumber, networkAddress, pulseWeight, creationDate, checkingDate, plombNumber, initialStatement, additionalInfo, warningStatementMax, warningStatementMin, errorStatementMax, errorStatementMin) {
      let meter = {
        serialNumber: serialNumber,
        idMeterType: idMeterType,
        idNode: idNode,
        transportSerial: transportSerial,
        idTransport: idTransport,
        idTransportChannelType: idTransportChannelType,
        transportChanelNumber: transportChanelNumber,
        networkAddress: networkAddress,
        pulseWeight: pulseWeight,
        creationDate: creationDate,
        checkingDate: checkingDate,
        plombNumber: plombNumber,
        initialStatement: initialStatement,
        additionalInfo: additionalInfo,

        warningStatementMax: warningStatementMax,
        warningStatementMin: warningStatementMin,
        errorStatementMax: errorStatementMax,
        errorStatementMin: errorStatementMin
      }
      return ApiService.post(`/api/meters`, meter)
    },

    update(id, serialNumber, idMeterType, idNode, transportSerial, idTransport, idTransportChannelType, transportChanelNumber, networkAddress, pulseWeight, creationDate, checkingDate, plombNumber, initialStatement, additionalInfo, warningStatementMax, warningStatementMin, errorStatementMax, errorStatementMin) {
      let meter = {
        id: id,
        serialNumber: serialNumber,
        idMeterType: idMeterType,
        idNode: idNode,
        transportSerial: transportSerial,
        idTransport: idTransport,
        idTransportChannelType: idTransportChannelType,
        transportChanelNumber: transportChanelNumber,
        networkAddress: networkAddress,
        pulseWeight: pulseWeight,
        creationDate: creationDate,
        checkingDate: checkingDate,
        plombNumber: plombNumber,
        initialStatement: initialStatement,
        additionalInfo: additionalInfo,

        warningStatementMax: warningStatementMax,
        warningStatementMin: warningStatementMin,
        errorStatementMax: errorStatementMax,
        errorStatementMin: errorStatementMin
      }
      return ApiService.put(`/api/meters`, meter)
    },

    archive(id) {
      return ApiService.put(`/api/meters/archive/${id}`)
    },

    restore(id) {
      return ApiService.put(`/api/meters/restore/${id}`)
    },

    delete(id) {
      return ApiService.delete(`/api/meters/${id}`)
    },

    linkTransport(id, idTransport, idTransportChannelType, transportChannelNumber, transportNetworkAddress, isTransport, isMeter) {
      let meterLink = {
        id: id,
        idTransport: idTransport,
        idTransportChannelType: idTransportChannelType,
        transportChannelNumber: transportChannelNumber,
        transportNetworkAddress: transportNetworkAddress,
        isTransport: isTransport,
        isMeter: isMeter
      }
      return ApiService.put(`/api/meters/link/transport`, meterLink)
    },

    unlinkTransport(id) {
      return ApiService.put(`/api/meters/unlink/transport/${id}`)
    },

    linkNode(id, idNode) {
      let meterLink = {
        id: id,
        idNode: idNode
      }
      return ApiService.put(`/api/meters/link/node`, meterLink)
    },

    unlinkNode(id) {
      return ApiService.put(`/api/meters/unlink/node/${id}`)
    },

    createType(idEnergyMeterType, tradeMark, type, diameter, checkingPeriod, qMin, qMax, analogMin, analogMax, isDiscreteInterfase, isAnalogInterfase, isRs232interfase, countDiscreteInputs, handler, hasStatements, hasConsumptions, almatySuIdApartment, almatySuIdHome, almatySuIdCompany, alsecoIdApartment) {
      let meterType = {
        idEnergyMeterType: idEnergyMeterType,
        tradeMark: tradeMark,
        type: type,
        diameter: diameter,
        checkingPeriod: checkingPeriod,
        qMin: qMin,
        qMax: qMax,
        analogMin: analogMin,
        analogMax: analogMax,
        isDiscreteInterfase: isDiscreteInterfase,
        isAnalogInterfase: isAnalogInterfase,
        isRs232interfase: isRs232interfase,
        countDiscreteInputs: countDiscreteInputs,
        handler: handler,
        hasStatements: hasStatements,
        hasConsumptions: hasConsumptions,
        almatySuIdApartment: almatySuIdApartment,
        almatySuIdHome: almatySuIdHome,
        almatySuIdCompany: almatySuIdCompany,
        alsecoIdApartment: alsecoIdApartment
      }
      return ApiService.post(`/api/meters/types`, meterType)
    },

    updateType(id, idEnergyMeterType, tradeMark, type, diameter, checkingPeriod, qMin, qMax, analogMin, analogMax, isDiscreteInterfase, isAnalogInterfase, isRs232interfase, countDiscreteInputs, handler, hasStatements, hasConsumptions, almatySuIdApartment, almatySuIdHome, almatySuIdCompany, alsecoIdApartment) {
      let meterType = {
        id: id,
        idEnergyMeterType: idEnergyMeterType,
        tradeMark: tradeMark,
        type: type,
        diameter: diameter,
        checkingPeriod: checkingPeriod,
        qMin: qMin,
        qMax: qMax,
        analogMin: analogMin,
        analogMax: analogMax,
        isDiscreteInterfase: isDiscreteInterfase,
        isAnalogInterfase: isAnalogInterfase,
        isRs232interfase: isRs232interfase,
        countDiscreteInputs: countDiscreteInputs,
        handler: handler,
        hasStatements: hasStatements,
        hasConsumptions: hasConsumptions, 
        almatySuIdApartment: almatySuIdApartment,
        almatySuIdHome: almatySuIdHome,
        almatySuIdCompany: almatySuIdCompany,
        alsecoIdApartment: alsecoIdApartment
      }
      return ApiService.put(`/api/meters/types`, meterType)
    },
    
    deleteType(id) {
      return ApiService.delete(`/api/meters/types/${id}`)
    },

    getTypes(idEnergyType, energyTypeCode, type, tradeMark) {
        return ApiService.get('api/meters/types', {
            params: {
                IdEnergyType: idEnergyType,
                EnergyTypeCode: energyTypeCode,
                Type: type,
                TradeMark: tradeMark
            }
        })
    },

    getTypesSimple(idEnergyType, energyTypeCode, type, tradeMark) {
        return ApiService.get('api/meters/types-simple', {
            params: {
                IdEnergyType: idEnergyType,
                EnergyTypeCode: energyTypeCode,
                Type: type,
                TradeMark: tradeMark
            }
        })
    },

    getEnergyMeterTypes(nodeId) {
        return ApiService.get('/api/meters/energy-types', {
            params: {
                NodeId: nodeId
            }
        })
    }
}

export default MeterService